module.exports = __webpack_public_path__ + "img/ico-fertilizante-w.1cbaefba.png";